import {
  FaTachometerAlt,
  FaUsers,
  FaFolderOpen,
  FaFileAlt,
  FaQuestionCircle,
  FaImages,
  FaShareAlt,
  FaNewspaper,
  FaQuoteLeft,
  FaYoutube,
  FaBookOpen,
  FaBriefcase
} from "react-icons/fa";

import { FaFileCircleQuestion } from "react-icons/fa6";

import { NavLink } from "react-router-dom";


function Sidebar({ sidebarOpen }) {

  return (

    <div
      className={`sidebar ${
        sidebarOpen ? "show-sidebar" : ""
      }`}
    >

      <div className="sidebar-top">

        <div className="logo-box">
          H.A
        </div>

        <h3>HomoeoAdda</h3>

      </div>


      <ul>

        {/* Dashboard */}

        <li>
          <NavLink to="/dashboard">
            <FaTachometerAlt />
            <span>Dashboard</span>
          </NavLink>
        </li>


        {/* Paper Categories */}

        <li>
          <NavLink to="/paper-category">
            <FaFolderOpen />
            <span>Paper Categories</span>
          </NavLink>
        </li>


        {/* Subjects */}

        <li>
          <NavLink to="/subjects">
            <FaFolderOpen />
            <span>Subjects</span>
          </NavLink>
        </li>


        {/* Papers */}

        <li>
          <NavLink to="/papers">
            <FaFileAlt />
            <span>Paper</span>
          </NavLink>
        </li>


        {/* Questions */}

        <li>
          <NavLink to="/questions">
            <FaQuestionCircle />
            <span>Questions</span>
          </NavLink>
        </li>


        {/* Paper Questions */}

        <li>
          <NavLink to="/paperquestions">
            <FaFileCircleQuestion />
            <span>Paper Questions</span>
          </NavLink>
        </li>


        {/* Users */}

        <li>
          <NavLink to="/users">
            <FaUsers />
            <span>Users</span>
          </NavLink>
        </li>
       <li>
        <NavLink to="/blogs">
          <FaNewspaper />
          <span>Blogs</span>
        </NavLink>
      </li>
      <li>
        <NavLink to="/testimonials">
            <FaQuoteLeft />
            <span>Testimonials</span>
        </NavLink>
    </li>
    <li>
        <NavLink to="/youtube-videos">
            <FaYoutube />
            <span>YouTube Videos</span>
        </NavLink>
    </li>

<li>
    <NavLink to="/free-study-material">
        <FaBookOpen />
        <span>Free Study Material</span>
    </NavLink>
</li>
<li>
    <NavLink to="/jobs">
        <FaBriefcase />
        <span>Jobs & Current Affairs</span>
    </NavLink>
</li>
<li>
    <NavLink to="/gallery">
        <FaImages />
        <span>Gallery Popup</span>
    </NavLink>
</li>


    <li>
    <NavLink to="/admin/results">
        <FaFileAlt />
        <span>Results</span>
    </NavLink>
</li>


        {/* Sliders */}

        <li>
          <NavLink to="/sliders">
            <FaImages />
            <span>Sliders</span>
          </NavLink>
        </li>


        {/* Social Links */}

        <li>
          <NavLink to="/social-links">
            <FaShareAlt />
            <span>Social Links</span>
          </NavLink>
        </li>


      </ul>

    </div>
  );
}


export default Sidebar;